module.exports = __webpack_public_path__ + "static/female-physiotherapist-chiropractor-adjusting-patients-neck-000de2e3fc17a76d4ba27f27c1b33ab4.webp";